export type NestedObject = { [key: string]: NestedObject | string }

export function getNestedValue(
  obj: NestedObject,
  path: string,
): string | undefined {
  const keys = path.split('.')
  let current: NestedObject | string = obj

  for (const key of keys) {
    if (
      typeof current === 'string' ||
      !current ||
      typeof current[key] === 'undefined'
    ) {
      return undefined
    }
    current = current[key]
  }

  return typeof current === 'string' ? current : undefined
}
